import * as React from "react"
import { Link } from "gatsby"

import Home from "../components/home"
import Seo from "../components/seo"

const JswebsitePage = () => (
  <Home>
  <div className="masthead-followup row m-0">
	  <div className="col-12 col-md-12 text-center">
      <Seo title="CREATE MODERN WEBSITE WITH JAVASCRIPT GATSBY ANGULAR REACT NEXTJS" />
    <h1><strong><a href="/jswebsite">MODERN WEBSITE SOLUTIONS</a></strong></h1>
   <p>
  Create a Modern website with javascript framework.
</p>
<hr/>
<p>
Select your favorite javascript framework and get strated to create or update your website with modern technology.
</p>
</div>
<div className="col-12 col-md-4 p-3 p-md-5 text-center">
<Link title="create website with gatsby js" className="p-3 p-md-5 shadow rounded btn btn-outline-primary" to="/gatsby">
<img width="512" alt="create website using modern technology javascript" src="icons/icon-384x384.png"/>
<h3>Gatsby</h3>
</Link>
    </div>
    <div className="col-12 col-md-4 p-3 p-md-5 text-center">
<Link title="create website with angular" className="p-3 p-md-5 shadow rounded btn btn-outline-danger" to="/angular">
<img class="img-fluid" width="512" alt="create website using modern technology javascript" src="https://mesinkasironline.web.app/img/createwebsiteusingangular.png"/>
<h3>Angular</h3>
</Link>
    </div>
    <div className="col-12 col-md-4 p-3 p-md-5 text-center">
<Link title="create website with react" className="p-3 p-md-5 shadow rounded btn btn-outline-info" to="/react">
<img class="img-fluid" alt="create website using modern technology javascript" src="https://mesinkasironline.web.app/img/createwebsiteusingreact.png"/>
<h3>React</h3>
</Link>
    </div>
    <div className="col-12 col-md-12 p-3 p-md-5 text-center">
<p>Javascript framework is a popular generation to create and build website, with using this technology make your website very fast and great for SEO too . with no loading this is a new technology for create and make your new modern website.</p>
    </div>
    <div className="col-12 col-md-12 text-center p-3 p-md-5">
<p>Explore all website design service and online shop</p>
  <Link to="/makewebsite" className="button">Explore all</Link>
  </div>
    </div>
  </Home>
)

export default JswebsitePage